import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

const initialState = {
  isLoading: false,
  items: [],
  total: 0,
  timeline: [],
  // Trazabilidad por producto — cada fila es una línea Pedido_Producto
  // (activa o eliminada) enriquecida con mesa/empleado/motivo. Ver
  // ProductTraceRow en el backend. Se llena con `searchProductTrace`.
  productTrace: [],
  productTraceLoading: false,
  error: null,
};

const slice = createSlice({
  name: "audit",
  initialState,
  reducers: {
    startLoading(state) { state.isLoading = true; state.error = null; },
    hasError(state, action) { state.isLoading = false; state.error = action.payload; },
    setItems(state, action) {
      state.isLoading = false;
      state.items = action.payload.items || [];
      state.total = action.payload.total || 0;
    },
    setTimeline(state, action) {
      state.isLoading = false;
      state.timeline = action.payload || [];
    },
    startProductTrace(state) {
      state.productTraceLoading = true;
      state.error = null;
    },
    setProductTrace(state, action) {
      state.productTraceLoading = false;
      state.productTrace = action.payload || [];
    },
    clearProductTrace(state) {
      state.productTrace = [];
      state.productTraceLoading = false;
    },
  },
});

export default slice.reducer;

export function searchAudit(query) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await axios.post("/audit/search", query || {});
      dispatch(slice.actions.setItems(res.data || { items: [], total: 0 }));
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message || "Error"));
    }
  };
}

export function getEmployeeTimeline(employeeId, take = 100) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await axios.get(`/audit/timeline/${employeeId}?take=${take}`);
      dispatch(slice.actions.setTimeline(res.data || []));
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message || "Error"));
    }
  };
}

// Trazabilidad por producto: acepta `{ productName, productoId, from, to,
// mesaId, idEmployee, onlyDeleted, take }` — al menos uno entre
// productName/productoId. Sin filtro el backend devuelve [] para no
// volcar todo el historial.
export function searchProductTrace(query) {
  return async (dispatch) => {
    dispatch(slice.actions.startProductTrace());
    try {
      const res = await axios.post("/audit/producttrace", query || {});
      dispatch(slice.actions.setProductTrace(res.data || []));
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message || "Error"));
      dispatch(slice.actions.setProductTrace([]));
    }
  };
}

export function clearProductTrace() {
  return (dispatch) => dispatch(slice.actions.clearProductTrace());
}
